// Third party libraries
import * as $ from 'jquery';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import ProductService from '@/app/services/main/product/product-service';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES } from "@/app/constants/constants";

export default {
	name: 'ModalAddProductToBundle',
	mixins: [toastMessageMixins, inputTextMixins],
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				selectedProduct: {},
				selectedQuantity: {}
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);

			return fields;
		},
		isInvalid() {
			return (this.$v.$invalid || this.selectedQuantity === 0);
		},
		hasNextPage() {
			return this.page < this.pageCount;
		},
		hasSubscription() {
			let flag = false;

			if (this.selectedProduct) {
				flag = this.selectedProduct.isSubscription;
			}

			return flag;
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		initializeModalData() {
			return {
				selectedProduct: null,
				productOptions: [],
				selectedQuantity: '',
				initialProductLoad: false,
                page: 1,
                pageCount: 2,
                observer: null,
				query: '',
				selectedAge: ''
			}
		},
		show(selectedAge) {
			// reset data on show
			this.clearFields();
			// Observer to watch our v-select when it reaches the end to trigger infinite scroll
			this.observer = new IntersectionObserver(this.infiniteScroll);
			$(this.$refs.modalAddProduct).modal('show');
			this.selectedAge = selectedAge;
			// show loader on initial load
			this.initialProductLoad = true;
			this.callProductsAPI()
				.then(() => {
					this.initialProductLoad = false;
				});
		},
		hideModal() {
			$(this.$refs.modalAddProduct).modal('hide');
		},
		addProductToBundle(option) {
			const product = {
				...this.selectedProduct,
				productQuantity: this.selectedQuantity
			}

			this.$emit('addProductToBundle', product);

			if (option === 'add') {
				this.hideModal();
			} else {
				this.clearFields('reset');
			}
		},
		getProducts(searchQuery = '') {
			this.query = searchQuery;
			this.delayTyping(async () => {
				// reset page to 1 when querying.
			    this.page = 1;
				await this.callProductsAPI(this.query);
			});
		},
		async onOpen() {
			// Observe the list-footer
            if (this.hasNextPage) {
            	// we need to wait for the nextTick for it to see our refs.
                await this.$nextTick();
                this.observer.observe(this.$refs.load);
            }
		},
		onClose() {
            this.observer.disconnect();
		},
        async infiniteScroll([{isIntersecting, target}]) {
		    if (isIntersecting) {
		    	// save the current scroll position before calling API
		    	const ul = target.offsetParent;
		    	const scrollTop = target.offsetParent.scrollTop;
		        this.page += 1;
			    await this.callProductsAPI(this.query);
			    // wait for our list to update before setting the previous scroll position.
			    await this.$nextTick();
			    ul.scrollTop = scrollTop;
		    }
        },
		callProductsAPI(query = '') {
			const queryParams = {
				limit: 10,
                page: this.page,
				'f_status': 'A',
				'f_name': query,
				desc: true
			};

			if (this.selectedAge) {
				queryParams['f_age'] = this.selectedAge;
			}

			return ProductService.getProducts(queryParams)
				.then( async res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const age = { A: 'Adult', P: 'Puppy' }
						const processedData = res.data.data.map(product => {
							return {
								id: product.id,
								name: product.name,
								price: product.price,
								brand: product.brand,
								imageUrl: product.imageUrl,
								productType: product.productType.name,
								isSubscription: product.subscriptionBundle,
								age: age[product.age] ? age[product.age] : 'Adult/Puppy'
							}
						});

						if (this.page !== 1) {
						    this.productOptions = [...this.productOptions, ...processedData];
                        } else {
						    this.productOptions = processedData;
                        }

						this.pageCount = res.data.pagination.pageCount;
					} else {
						this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res);
					}
				});
		},
		onBlur() {
			this.$v.selectedProduct.$touch();
		},
		handleInputEvent({isSubscription}) {
			if (isSubscription) {
				this.selectedQuantity = '1';
			} else {
				this.selectedQuantity = '';
			}
		},
		numberOnlyInput(event) {
			let charCode = (event.which) ? event.which : event.keyCode;

			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				event.preventDefault();
			} else {
				return true;
			}
		},
		convertToInt() {
			let intQty = parseInt(this.selectedQuantity);

			if (isNaN(intQty)) {
				this.selectedQuantity = null;
			} else {
				this.selectedQuantity = intQty;
			}
		},
		clearFields(option) {
			if (option === 'reset') {
				this.selectedProduct = null;
				this.selectedQuantity = '';
			} else {
				Object.assign(this.$data, this.initializeModalData());
			}

			this.$v.$reset();
		},
		hasProductImage(productImage) {
			let image = require('@/assets/images/temporary/product-image.png');

			if (productImage) {
				image = productImage;
			}

			return image;
		}
	},
	validations() {
		return this.validationRules;
	}
}